<template>
  <div>
    <template v-if="loading">
      <place-full-loading />
    </template>
    <template v-else-if="!place.isGooglePlace && !place.isEkispertPlace && !place.isGeocode">
      <div v-if="placeFull.images && placeFull.images.length > 0" class="text-center">
        <progressive-img :src="placeFull.images[imageIndex].url" class="w-full" />
        <div v-if="placeFull.images.length >= 2">
          <span><a @click="prevImage" class="text-gray-600 text-sm" :class="imageIndex > 0 ? 'visible' : 'invisible'">＜ 前の画像</a></span>
          ({{ imageIndex + 1 }}/{{ placeFull.images.length }})
          <span><a @click="nextImage" class="text-gray-600 text-sm" :class="imageIndex < placeFull.images.length - 1 ? 'visible' : 'invisible'">次の画像 ＞</a></span>
        </div>
      </div>
      <div v-else-if="placeFull.img_main && placeFull.img_main.length > 0" class="text-center">
        <progressive-img :src="placeFull.img_main" class="w-full" />
      </div>
      <template v-if="genreId == 'chofu_cycle'">
        <place-cycle :place="placeFull" />
      </template>
      <template v-else-if="genreId == 'demand'">
        <place-busstop :place="placeFull" />
      </template>
      <template v-else-if="place.isEkispertPlace">
        <place-ekispert-place :place="place" />
      </template>
      <template v-else-if="place.isGooglePlace">
        <place-google-place :place="place" />
      </template>
      <template v-else>
        <place-poi :place="placeFull">
          <slot></slot>
        </place-poi>
      </template>
    </template>
  </div>
</template>

<script>
import PlacePoi from './PlacePoi'
import PlaceCycle from './PlaceCycle'
import PlaceBusstop from './PlaceBusstop'
import PlaceGooglePlace from './PlaceGooglePlace'
import PlaceEkispertPlace from './PlaceEkispertPlace'
import PlaceFullLoading from './PlaceFullLoading'

import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  props: {
    place: {
      type: Object,
      required: true
    }
  },
  components: {
    PlacePoi,
    PlaceCycle,
    PlaceBusstop,
    PlaceGooglePlace,
    PlaceEkispertPlace,
    PlaceFullLoading
  },
  data () {
    return {
      loading: false,
      imageIndex: 0
    }
  },
  created () {
    this.updateDetail(this.place)
  },
  methods: {
    updateDetail: function (newPlace) {
      if (!_.isEmpty(newPlace) && !newPlace.isGooglePlace && !newPlace.isEkispertPlace) {
        this.loading = true
        this.$store.dispatch('places/fetchPlace', newPlace.id)
          .finally(() => {
            this.loading = false
          })
      }
    },
    prevImage: function () {
      this.imageIndex--
    },
    nextImage: function () {
      this.imageIndex++
    }
  },
  computed: {
    ...mapGetters({
      placeFull: 'places/getPlaceFull'
    }),
    genreId: function () {
      return this.place.genreIds && this.place.genreIds[0]
    }
  },
  watch: {
    place: function (newPlace) {
      this.updateDetail(newPlace)
    }
  }
}
</script>
